import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TableImage from '../../shared/Image/TableImage';
import { dateConversions } from '../../utils/commonFunctions';
import { CustomGridLayout } from '../../shared/Cards/CustomCard';
import FilterComponent from '../../components/FilterComponent';
import useFilters from '../../hooks/useFilters';
import CustomTable from '../../shared/Table/CustomTable';
import CustomDialog from '../../shared/Overlays/CustomDialog';
import PrimaryButton from '../../shared/Button/CustomButton';
import { CustomInput, CustomInputMask, CustomInputNumber } from '../../shared/Input/AllInputs';
import { useDispatch, useSelector } from 'react-redux';
import { editCalendarEventMember, getCalendarBooking } from '../../redux/actions/Calendar/CalendarAction';
import { getMembers } from '../../redux/actions/MembersPortal/memberPortalActions';
import { showToast } from '../../redux/actions/toastAction';

const AddMember = ({ openMemberList, setOpenMemberList, member, maximumWaitlist }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getMembers());
    }, [dispatch]);
    const { members } = useSelector((state) => state.membersPortal);
    const [filteredMembers, setFilteredMembers] = useState([]);

    useEffect(() => {
        if (members) {
            const idsToMatch = member?.map((item) => item?.member) || [];
            const filteredMembers = members?.filter((item) => !idsToMatch.includes(item._id)) || [];
            setFilteredMembers(filteredMembers);
        }
    }, [member]);

    const { id } = useParams();
    const handleSave = () => {
        if (selected.length > maximumWaitlist) {
            dispatch(showToast({ severity: 'error', summary: 'You cannot add more members than the maximum waitlist limit.' }));
        } else {
            dispatch(
                editCalendarEventMember(id, setLoading, { members: selected?.map((item) => ({ member: item._id, isMemberVerified: false })) }, () => {
                    setOpenMemberList(false);
                    setSelected([]);
                    dispatch(getCalendarBooking(id));
                }),
            );
        }
    };

    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const columns = [
        { selectionMode: 'multiple', headerStyle: '' },
        { field: 'image', body: ({ image }) => <TableImage image={image} />, header: 'Photo', style: { color: '#d0e1fd', width: '12%' } },
        {
            field: 'fullName',
            body: (r) => r?.firstName + ' ' + r?.lastName,
            header: 'Name',
            style: { width: '12%' },
        },
        { field: 'agreement', header: 'Agreement #' },
        { field: 'primaryPhone', header: 'Primary Phone' },
        { field: 'dob', body: (r) => dateConversions(r?.dob), header: 'BirthDate' },
        { field: '', header: 'Membership Type' },
        { field: 'barCode', header: 'Barcode' },
        { field: '', header: 'Status/Reason' },
    ];

    const handleChange = ({ name, value }) => {
        setData((prev) => ({ ...prev, [name]: value }));
    };
    const { tableData, onFilterOpen, onFilterClose, onApplyFilters, filters, isFilterVisible } = useFilters(filteredMembers);
    const initialState = {
        firstName: '',
        lastName: '',
        barCode: null,
        agreement: '',
        primaryPhone: '',
    };
    const [data, setData] = useState(initialState);

    return (
        <>
            <CustomDialog
                title={'Add Members'}
                visible={openMemberList}
                onCancel={() => {
                    setOpenMemberList(false);
                    setSelected(null);
                }}
                loading={loading}
                onSave={handleSave}
                width="auto"
            >
                <PrimaryButton label="Filter" icon="pi pi-filter" className=" m-0" onClick={onFilterOpen} />
                <CustomGridLayout>
                    <FilterComponent
                        value={filters}
                        onApply={onApplyFilters}
                        visible={isFilterVisible}
                        onHide={onFilterClose}
                        data={data}
                        handleChange={handleChange}
                        setData={setData}
                    >
                        <CustomGridLayout>
                            <CustomInput name="firstName" data={data} onChange={handleChange} col={12} />
                            <CustomInput name="lastName" data={data} onChange={handleChange} col={12} />
                            <CustomInput name="barCode" data={data} onChange={handleChange} col={12} />
                            <CustomInput name="agreement" data={data} onChange={handleChange} col={12} />
                            <CustomInputMask name="primaryPhone" mask="(999) 999-9999" data={data} onChange={handleChange} col={12} />
                        </CustomGridLayout>
                    </FilterComponent>
                    <CustomTable data={tableData} columns={columns} selectedRow={selected} setSelectedRow={setSelected} />
                </CustomGridLayout>
            </CustomDialog>
        </>
    );
};

export default AddMember;
